<div ngForm (keydown.enter)="onEnterPressed()">
  <app-input [title]="'Email Address' | translate" [name]="'email'" [(ngModel)]="email" [readonly]="readOnlyEmail" email
    required></app-input>
  <app-input #inputPassword [title]="'Password' | translate" [name]="'password'" [type]="'password'" [(ngModel)]="password" required>
  </app-input>
  <app-checkbox *ngIf="showRememberMe" [title]="'Remember login' | translate" [name]="'rememberMe'"
    [(ngModel)]="rememberMe"></app-checkbox>
  <div *ngIf="!showRememberMe" class="empty-element">
    <div class="checkbox"><label><span class="infotext">&nbsp;</span></label></div>
  </div>
  <app-reset-password *ngIf="canResetPassword" [email]="email" [readonly]="readOnlyEmail" (resetPassword)="onResetPassword($event)">
  </app-reset-password>
  <div *ngIf="showRegistrationUrl" class="list-group create-account-callout">
    <div class="list-group-item list-group-item-light">
      {{ 'Don\'t you have an account yet?' | translate }} <a (click)="onRegister()">{{'Create now' | translate}}</a>
    </div>
  </div>
  <app-backward-forward [hideBack]="!showBack" (backwardClick)="onBack()" [nextTitle]="'Sign In' | translate"
    (forwardClick)="login(email, password, rememberMe)" [forwardEnabled]="isFormValid">
  </app-backward-forward>
  <!-- <app-button [disabled]="!isFormValid" [title]="'Sign In' | translate" (click)="login(email, password, rememberMe)"></app-button> -->
</div>
